import React, { useEffect, useRef, useState } from "react";
import {
  CourseTaskSideBarCard,
  StudentSpecificDataBtn,
  StudentSpecificDataList,
} from ".";
import { useImmer } from "use-immer";
import { ModalLayout } from "shared";
import { TaskListingText } from "..";
import { useAppScope } from "master";

export const CourseTaskSideBar = ({
  name = "",
  studentTasks = [],
  currentCourseTask,
  onCourseTaskCardClick,
  onCourseCardNavigate,
  isMobile,
  studentDataDisplayName,
  modalState,
  onOpenModal,
  onCloseModal,
  studentSpecificDataQuery,
  courseType,
  displayDuration,
}) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const [studentSpecificData, setStudentSpecificData] = useImmer(null);
  const currentButtonRef = useRef(null);
  const { isMWCD, lanSettings } = useAppScope();

  useEffect(() => {
    if (currentButtonRef.current) {
      currentButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: firstLoad ? "center" : "start",
      });
      if (firstLoad) {
        setFirstLoad(false);
      }
    }
  }, [currentButtonRef, currentCourseTask]);

  useEffect(() => {
    if (studentSpecificDataQuery?.data) {
      setStudentSpecificData(
        studentSpecificDataQuery?.data
          ? studentSpecificDataQuery.data.map((item) => {
            if (item.endsWith(",}")) {
              const element = item.replace(/,(?=[^,]*$)/, "");
              return JSON.parse(element);
            } else {
              return JSON.parse(item);
            }
          })
          : null
      );
    }
  }, [studentSpecificDataQuery?.data]);

  return (
    <div className={`col-12 col-md-4 single-page-sidebar ${isMWCD ? "reduced-height" : ""}`}>
      <div className="sidebar-header">
        <h3>{name}</h3>
        {!!studentDataDisplayName && (
          <StudentSpecificDataBtn
            onOpenModal={onOpenModal}
            studentDataDisplayName={studentDataDisplayName}
          />
        )}
        <div className="border-top mt-3 pt-2 sidebar-sub-heading">
          {TaskListingText.CourseTopics[lanSettings?.lan || "en"]}
        </div>
      </div>
      <div className="sidebar-content scrollbar-style">
        <ul className="sidebar-item-list">
          {studentTasks &&
            studentTasks?.length > 0 &&
            studentTasks?.map((element, index) => {
              const isCurrent = element?.id === currentCourseTask?.id;
              return (
                <CourseTaskSideBarCard
                  sino={index + 1}
                  key={element?.id}
                  ref={isCurrent ? currentButtonRef : null}
                  title={element?.title}
                  taskGroup={element?.taskGroup}
                  isComplete={element?.studentTaskStatus === 2}
                  courseType={courseType}
                  duration={element?.taskDuration}
                  isCurrent={
                    currentCourseTask?.courseTaskId === element?.courseTaskId
                  }
                  onClick={() => {
                    isMobile
                      ? onCourseCardNavigate(element)
                      : onCourseTaskCardClick(element);
                  }}
                  displayDuration={displayDuration}
                />
              );
            })}
        </ul>
      </div>
      {modalState?.isOpen &&
        modalState?.actionFrom === "student_specific_data" && (
          <ModalLayout
            customClass={"activation_code"}
            isOpen={modalState.isOpen}
            modalStyle={{ maxWidth: "450px" }}
            modalBody={
              <StudentSpecificDataList
                studentDataDisplayName={studentDataDisplayName}
                studentSpecificData={studentSpecificData}
                studentSpecificDataQuery={studentSpecificDataQuery}
                onCloseModal={onCloseModal}
              />
            }
            modalButtonGroup={<></>}
          />
        )}
    </div>
  );
};
